import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'list-site-components' as const;

const argumentZod = z.object({
  limit: z
    .number()
    .int()
    .min(1)
    .max(100)
    .optional()
    .describe('Max components to return per page (1-100, default 100)'),
  offset: z
    .number()
    .int()
    .min(0)
    .optional()
    .describe('Number of components to skip for pagination (default 0)'),
});

export const listSiteComponentsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List site components',
  prettyStatus: {
    executing: 'Listing components…',
    executed: 'Listed components',
    failed: 'Listing components failed',
  },
  family: 'localization',
  llmTool: {
    name: toolName,
    description:
      'Lists the components (symbols) defined on the current site, paginated. Each component has an id -- use it with get-component-properties to see its translatable properties, or with create-translation-exclusions (kind: component-prop) to exclude the whole component or one of its properties from translation.',
    inputSchema: argumentZod,
  },
  type: 'server',
  requiredScopes: ['sites:read'],
  permission: [{resource: 'Site', action: 'read'}],
  confirmBeforeExecuting: false,
  isReadOnly: () => true,
});

export type ListSiteComponentsArgumentType = z.infer<typeof argumentZod>;
